import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function useDocumentTitle(
  titleKey,
  fallbackTitle = "Hybrid Energy Rock"
) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const currentTitle = useRef(null);

  useEffect(() => {
    const updateTitle = () => {
      const newTitle = titleKey
        ? t(`pageTitle.${titleKey}`, { defaultValue: fallbackTitle })
        : fallbackTitle;
      document.title = newTitle;
      currentTitle.current = newTitle;
      sessionStorage.setItem("currentTitle", newTitle);
      sessionStorage.setItem("currentPath", location.pathname);
    };

    updateTitle();

    const resetTitle = () => {
      if (currentTitle.current) {
        document.title = currentTitle.current;
      }
    };

    document.addEventListener("visibilitychange", resetTitle);
    window.addEventListener("focus", resetTitle);
    window.addEventListener("popstate", updateTitle);
    window.addEventListener("load", updateTitle);

    return () => {
      document.removeEventListener("visibilitychange", resetTitle);
      window.removeEventListener("focus", resetTitle);
      window.removeEventListener("popstate", updateTitle);
      window.removeEventListener("load", updateTitle);
    };
  }, [titleKey, t, fallbackTitle, location.pathname, i18n.language]);
}
